<template>
  <div class="loginContainer">
    <div class="grid imgGrid">
      <img
        class="imgContainer"
        src="@/assets/images/mosquita_create_account.png"
      />
      <p class="nunitoBold subheaderText">{{ $t('k_signin_title') }}</p>
    </div>
    <div class="grid mt-10 fbGrid">
      <div class="fbButton registerButton">
        <div class="centeredButtonContent">
          <img class="fbLogo" src="@/assets/images/Facebook_Icon.png" />
          <div
            class="buttonCaption nunitoBold"
            v-on:click="loginSocial('facebook')"
          >
            {{ $t('k_login_button_fb') }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-6 appleGrid">
      <div class="appleButton registerButton">
        <div class="centeredButtonContent">
          <img class="appleLogo" src="@/assets/images/Apple_icon.png" />
          <div
            class="buttonCaption nunitoBold"
            v-on:click="loginSocial('apple')"
          >
            {{ $t('k_login_button_apple') }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 grid hrLineGrid">
      <span class="ralewayRegular hrLine">{{
        $t('k_signup_button_mail')
      }}</span>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="formContainer">
        <div class="formElement">
          <label class="ralewayRegular formInputLabel" for="email">{{
            $t('k_email_type')
          }}</label>
          <ValidationProvider
            name="email"
            rules="email|required|max:48"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="text"
              name="email"
              v-model="email"
              v-bind:placeholder="$t('k_email_type')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="formElement mt-4">
          <label class="ralewayRegular formInputLabel" for="password">{{
            $t('k_pw_type')
          }}</label>
          <ValidationProvider
            name="password"
            rules="min:6|required|max:20"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="password"
              name="password"
              v-model="password"
              v-bind:placeholder="$t('k_pw_type')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="formElement mt-4">
          <router-link to="/forgot"
            ><span class="signLink ralewayBold">
              {{ $t('k_reset_pw_title') }}</span
            >
          </router-link>
        </div>
      </div>

      <div class="grid mt-10 stButtonGrid">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="submit()">
            {{ $t('k_signup_button') }}
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="signText ralewayRegular">
          {{ $t('k_no_account_yet') }} </span
        ><router-link :to="{ path: '/', query: query }"
          ><span class="signLink ralewayBold">
            {{ $t('k_signup_subtitle') }}</span
          ></router-link
        >
      </div>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import api from '.././plugins/api'
import { isFeatureEnabled } from '../services/parameters'
import { trackEvent } from '../plugins/analyticsTracker'
import { socialLoginRegister } from '../services/socialUtils'
import { ValidationProvider } from 'vee-validate'
import { getRedirectAfterRegisterLogin } from '../services/redirectHelper'

export default {
  components: {
    ValidationProvider
  },
  data() {
    return {
      email: '',
      password: '',
      error: false,
      errorText: '',
      accept: false,
      fbLoginEnabled: false,
      appleLoginEnabled: false,
      tagsSocial: [],
      query: null
    }
  },
  async mounted() {
    this.query = this.$route.query
    console.log(this.query)
    this.fbLoginEnabled = await isFeatureEnabled('fblogin')
    this.appleLoginEnabled = await isFeatureEnabled('applelogin')
  },
  methods: {
    loginSocial: async function(providerName) {
      try {
        trackEvent(
          providerName == 'facebook'
            ? this.$constants.WEB_LOGIN_FBLOGIN
            : this.$constants.WEB_LOGIN_APPLELOGIN
        )
        const token = await socialLoginRegister(providerName, this.$i18n.locale)
        localStorage.setItem('access_token', token)
        this.tagsSocial.push(providerName)
        await this.getUser()
        trackEvent(this.$constants.WEB_AUTH_LOGIN, { provider: providerName })
        const path = getRedirectAfterRegisterLogin(this.query)
        this.$router.push({
          path: path,
          query: this.query
        })
      } catch (errorFirebase) {
        await this.$store.dispatch('cleanAll')
        console.log(errorFirebase)
        trackEvent(this.$constants.WEB_AUTH_ERROR, { provider: providerName })
        if (
          errorFirebase.code == 'auth/account-exists-with-different-credential'
        ) {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_register_error_social',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
          this.$router.push({
            path: '/error',
            query: this.query
          })
        } else if (
          errorFirebase.code != 'auth/cancelled-popup-request' &&
          errorFirebase.code != 'auth/popup-closed-by-user'
        ) {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_generic_error_subtitle',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
          this.$router.push({
            path: '/error',
            query: this.query
          })
        }
      }
    },
    submit: async function() {
      trackEvent(this.$constants.WEB_LOGIN_EMAILLOGIN)
      try {
        this.error = false
        this.email = this.email ? this.email.trim() : this.email
        const firebaseUserRes = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
        const tokenFirebase = await firebaseUserRes.user.getIdToken()
        const tokenResponse = await api.post(
          '/user/token',
          { token: tokenFirebase },
          { headers: { Authorization: tokenFirebase } }
        )
        const token = tokenResponse.data.token
        localStorage.setItem('access_token', token)
        await this.getUser()
        trackEvent(this.$constants.WEB_AUTH_LOGIN, { provider: 'email' })
        const path = getRedirectAfterRegisterLogin(this.query)
        this.$router.push({
          path: path,
          query: this.query
        })
      } catch (errorFirebase) {
        await this.$store.dispatch('cleanAll')
        localStorage.removeItem('access_token')
        console.log(errorFirebase)
        trackEvent(this.$constants.WEB_AUTH_ERROR, { provider: 'email' })
        if (
          errorFirebase.code == 'auth/account-exists-with-different-credential'
        ) {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_login_error_email_not_exist',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
        } else if (errorFirebase.code == 'auth/wrong-password') {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_login_error_pw_not_valid',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
        } else {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_generic_error_subtitle',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
        }
        this.$router.push({
          path: '/error'
        })
      }
    },
    getUser: async function() {
      const urlGet = process.env.VUE_APP_BACKEND_URL
      const userResponse = await api.get(urlGet + '/user')
      localStorage.setItem('userInfo', JSON.stringify(userResponse.data.user))
      await this.$store.dispatch(
        'updateUserInfo',
        JSON.parse(JSON.stringify(userResponse.data.user))
      )
      const tagsToAdd = [...this.tagsSocial]
      await api.post(urlGet + '/user/tags/add', { tags: tagsToAdd })
      trackEvent(
        this.$constants.ST_LOGIN_WEB,
        { user: userResponse.data.user, lang: this.$i18n.locale },
        true
      )
    }
  }
}
</script>
<style lang="scss">
.loginContainer {
  .centeredButtonContent {
    grid-row: 1;
    grid-column: 2/12;
    display: flex;
    align-items: center;
  }

  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .fbLogo {
    align-self: center;
    width: 6%;
  }

  .appleLogo {
    align-self: center;
    width: 6%;
    padding-bottom: 0.4em;
  }

  .buttonCaption {
    font-size: 1em;
    flex-grow: 2;
    text-align: left;
    margin-left: 1em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1em;
  }

  .hrLine {
    display: flex;
    grid-row: 1;
    grid-column: 2/12;
    text-align: center;
    align-items: center;
  }

  .hrLine:before,
  .hrLine:after {
    color: white;
    content: '';
    flex: 1;
    border-bottom: 0.2px solid var(--line2);
    margin: auto 0.25em;
    padding-top: 0.25em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }

  @media screen and (min-width: 620px) {
    .formContainer {
      max-width: 600px;
      margin: auto;
    }

    .fbGrid {
      max-width: 600px;
      margin: auto;
    }

    .appleGrid {
      max-width: 600px;
      margin: auto;
    }

    .hrLineGrid {
      max-width: 600px;
      margin: auto;
    }

    .stButtonGrid {
      max-width: 600px;
      margin: auto;
    }
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
